import { BlueyonderCountry } from './blueyonder-user-country.model';

export const blueyonderCountries: BlueyonderCountry[] = [
  {
    'countryId': 'ABW',
    'countryName': 'ARUBA'
  },
  {
    'countryId': 'AFG',
    'countryName': 'AFGHANISTAN'
  },
  {
    'countryId': 'AGO',
    'countryName': 'ANGOLA'
  },
  {
    'countryId': 'AIA',
    'countryName': 'ANGUILLA'
  },
  {
    'countryId': 'ALB',
    'countryName': 'ALBANIA'
  },
  {
    'countryId': 'AND',
    'countryName': 'ANDORRA'
  },
  {
    'countryId': 'ANT',
    'countryName': 'NETHERLANDS ANTILLES'
  },
  {
    'countryId': 'ARE',
    'countryName': 'UNITED ARAB EMIRATES'
  },
  {
    'countryId': 'ARG',
    'countryName': 'ARGENTINA'
  },
  {
    'countryId': 'ARM',
    'countryName': 'ARMENIA'
  },
  {
    'countryId': 'ASM',
    'countryName': 'AMERICAN SAMOA'
  },
  {
    'countryId': 'ATA',
    'countryName': 'ANTARCTICA'
  },
  {
    'countryId': 'ATF',
    'countryName': 'FRENCH SOUTHERN TERRITORIES'
  },
  {
    'countryId': 'ATG',
    'countryName': 'ANTIGUA AND BARBUDA'
  },
  {
    'countryId': 'AUS',
    'countryName': 'AUSTRALIA'
  },
  {
    'countryId': 'AUT',
    'countryName': 'AUSTRIA'
  },
  {
    'countryId': 'AZE',
    'countryName': 'AZERBAIJAN'
  },
  {
    'countryId': 'BDI',
    'countryName': 'BURUNDI'
  },
  {
    'countryId': 'BEL',
    'countryName': 'BELGIUM'
  },
  {
    'countryId': 'BEN',
    'countryName': 'BENIN'
  },
  {
    'countryId': 'BFA',
    'countryName': 'BURKINA FASO'
  },
  {
    'countryId': 'BGD',
    'countryName': 'BANGLADESH'
  },
  {
    'countryId': 'BGR',
    'countryName': 'BULGARIA'
  },
  {
    'countryId': 'BHR',
    'countryName': 'BAHRAIN'
  },
  {
    'countryId': 'BHS',
    'countryName': 'BAHAMAS'
  },
  {
    'countryId': 'BIH',
    'countryName': 'BOSNIA AND HERZEGOWINA'
  },
  {
    'countryId': 'BLR',
    'countryName': 'BELARUS'
  },
  {
    'countryId': 'BLZ',
    'countryName': 'BELIZE'
  },
  {
    'countryId': 'BMU',
    'countryName': 'BERMUDA'
  },
  {
    'countryId': 'BOL',
    'countryName': 'BOLIVIA'
  },
  {
    'countryId': 'BRA',
    'countryName': 'BRAZIL'
  },
  {
    'countryId': 'BRB',
    'countryName': 'BARBADOS'
  },
  {
    'countryId': 'BRN',
    'countryName': 'BRUNEI DARUSSALAM'
  },
  {
    'countryId': 'BTN',
    'countryName': 'BHUTAN'
  },
  {
    'countryId': 'BVT',
    'countryName': 'BOUVET ISLAND'
  },
  {
    'countryId': 'BWA',
    'countryName': 'BOTSWANA'
  },
  {
    'countryId': 'CAF',
    'countryName': 'CENTRAL AFRICAN REPUBLIC'
  },
  {
    'countryId': 'CAN',
    'countryName': 'CANADA'
  },
  {
    'countryId': 'CCK',
    'countryName': 'COCOS  KEELING  ISLANDS'
  },
  {
    'countryId': 'CHE',
    'countryName': 'SWITZERLAND'
  },
  {
    'countryId': 'CHL',
    'countryName': 'CHILE'
  },
  {
    'countryId': 'CHN',
    'countryName': 'CHINA'
  },
  {
    'countryId': 'CIV',
    'countryName': 'COTE D\'IVOIRE'
  },
  {
    'countryId': 'CMR',
    'countryName': 'CAMEROON'
  },
  {
    'countryId': 'COD',
    'countryName': 'CONGO, THE DEMOCRATIC REPUBLIC OF THE'
  },
  {
    'countryId': 'COG',
    'countryName': 'CONGO'
  },
  {
    'countryId': 'COK',
    'countryName': 'COOK ISLANDS'
  },
  {
    'countryId': 'COL',
    'countryName': 'COLOMBIA'
  },
  {
    'countryId': 'COM',
    'countryName': 'COMOROS'
  },
  {
    'countryId': 'CPV',
    'countryName': 'CAPE VERDE'
  },
  {
    'countryId': 'CRI',
    'countryName': 'COSTA RICA'
  },
  {
    'countryId': 'CUB',
    'countryName': 'CUBA'
  },
  {
    'countryId': 'CXR',
    'countryName': 'CHRISTMAS ISLAND'
  },
  {
    'countryId': 'CYM',
    'countryName': 'CAYMAN ISLANDS'
  },
  {
    'countryId': 'CYP',
    'countryName': 'CYPRUS'
  },
  {
    'countryId': 'CZE',
    'countryName': 'CZECH REPUBLIC'
  },
  {
    'countryId': 'DEU',
    'countryName': 'GERMANY'
  },
  {
    'countryId': 'DJI',
    'countryName': 'DJIBOUTI'
  },
  {
    'countryId': 'DMA',
    'countryName': 'DOMINICA'
  },
  {
    'countryId': 'DNK',
    'countryName': 'DENMARK'
  },
  {
    'countryId': 'DOM',
    'countryName': 'DOMINICAN REPUBLIC'
  },
  {
    'countryId': 'DZA',
    'countryName': 'ALGERIA'
  },
  {
    'countryId': 'ECU',
    'countryName': 'ECUADOR'
  },
  {
    'countryId': 'EGY',
    'countryName': 'EGYPT'
  },
  {
    'countryId': 'ERI',
    'countryName': 'ERITREA'
  },
  {
    'countryId': 'ESH',
    'countryName': 'WESTERN SAHARA'
  },
  {
    'countryId': 'ESP',
    'countryName': 'SPAIN'
  },
  {
    'countryId': 'EST',
    'countryName': 'ESTONIA'
  },
  {
    'countryId': 'ETH',
    'countryName': 'ETHIOPIA'
  },
  {
    'countryId': 'FIN',
    'countryName': 'FINLAND'
  },
  {
    'countryId': 'FJI',
    'countryName': 'FIJI'
  },
  {
    'countryId': 'FLK',
    'countryName': 'FALKLAND ISLANDS  MALVINAS'
  },
  {
    'countryId': 'FRA',
    'countryName': 'FRANCE'
  },
  {
    'countryId': 'FRO',
    'countryName': 'FAROE ISLANDS'
  },
  {
    'countryId': 'FSM',
    'countryName': 'MICRONESIA, FEDERATED STATES OF'
  },
  {
    'countryId': 'FXX',
    'countryName': 'FRANCE, METROPOLITAN'
  },
  {
    'countryId': 'GAB',
    'countryName': 'GABON'
  },
  {
    'countryId': 'GBR',
    'countryName': 'UNITED KINGDOM'
  },
  {
    'countryId': 'GEO',
    'countryName': 'GEORGIA'
  },
  {
    'countryId': 'GHA',
    'countryName': 'GHANA'
  },
  {
    'countryId': 'GIB',
    'countryName': 'GIBRALTAR'
  },
  {
    'countryId': 'GIN',
    'countryName': 'GUINEA'
  },
  {
    'countryId': 'GLP',
    'countryName': 'GUADELOUPE'
  },
  {
    'countryId': 'GMB',
    'countryName': 'GAMBIA'
  },
  {
    'countryId': 'GNB',
    'countryName': 'GUINEA-BISSAU'
  },
  {
    'countryId': 'GNQ',
    'countryName': 'EQUATORIAL GUINEA'
  },
  {
    'countryId': 'GRC',
    'countryName': 'GREECE'
  },
  {
    'countryId': 'GRD',
    'countryName': 'GRENADA'
  },
  {
    'countryId': 'GRL',
    'countryName': 'GREENLAND'
  },
  {
    'countryId': 'GTM',
    'countryName': 'GUATEMALA'
  },
  {
    'countryId': 'GUF',
    'countryName': 'FRENCH GUIANA'
  },
  {
    'countryId': 'GUM',
    'countryName': 'GUAM'
  },
  {
    'countryId': 'GUY',
    'countryName': 'GUYANA'
  },
  {
    'countryId': 'HKG',
    'countryName': 'HONG KONG'
  },
  {
    'countryId': 'HMD',
    'countryName': 'HEARD AND MC DONALD ISLANDS'
  },
  {
    'countryId': 'HND',
    'countryName': 'HONDURAS'
  },
  {
    'countryId': 'HRV',
    'countryName': 'CROATIA  local name: Hrvatska'
  },
  {
    'countryId': 'HTI',
    'countryName': 'HAITI'
  },
  {
    'countryId': 'HUN',
    'countryName': 'HUNGARY'
  },
  {
    'countryId': 'IDN',
    'countryName': 'INDONESIA'
  },
  {
    'countryId': 'IND',
    'countryName': 'INDIA'
  },
  {
    'countryId': 'IOT',
    'countryName': 'BRITISH INDIAN OCEAN TERRITORY'
  },
  {
    'countryId': 'IRL',
    'countryName': 'IRELAND'
  },
  {
    'countryId': 'IRN',
    'countryName': 'IRAN  ISLAMIC REPUBLIC OF'
  },
  {
    'countryId': 'IRQ',
    'countryName': 'IRAQ'
  },
  {
    'countryId': 'ISL',
    'countryName': 'ICELAND'
  },
  {
    'countryId': 'ISR',
    'countryName': 'ISRAEL'
  },
  {
    'countryId': 'ITA',
    'countryName': 'ITALY'
  },
  {
    'countryId': 'JAM',
    'countryName': 'JAMAICA'
  },
  {
    'countryId': 'JOR',
    'countryName': 'JORDAN'
  },
  {
    'countryId': 'JPN',
    'countryName': 'JAPAN'
  },
  {
    'countryId': 'KAZ',
    'countryName': 'KAZAKHSTAN'
  },
  {
    'countryId': 'KEN',
    'countryName': 'KENYA'
  },
  {
    'countryId': 'KGZ',
    'countryName': 'KYRGYZSTAN'
  },
  {
    'countryId': 'KHM',
    'countryName': 'CAMBODIA'
  },
  {
    'countryId': 'KIR',
    'countryName': 'KIRIBATI'
  },
  {
    'countryId': 'KNA',
    'countryName': 'SAINT KITTS AND NEVIS'
  },
  {
    'countryId': 'KOR',
    'countryName': 'KOREA, REPUBLIC OF'
  },
  {
    'countryId': 'KWT',
    'countryName': 'KUWAIT'
  },
  {
    'countryId': 'LAO',
    'countryName': 'LAO PEOPLE\'S DEMOCRATIC REPUBLIC'
  },
  {
    'countryId': 'LBN',
    'countryName': 'LEBANON'
  },
  {
    'countryId': 'LBR',
    'countryName': 'LIBERIA'
  },
  {
    'countryId': 'LBY',
    'countryName': 'LIBYAN ARAB JAMAHIRIYA'
  },
  {
    'countryId': 'LCA',
    'countryName': 'SAINT LUCIA'
  },
  {
    'countryId': 'LIE',
    'countryName': 'LIECHTENSTEIN'
  },
  {
    'countryId': 'LKA',
    'countryName': 'SRI LANKA'
  },
  {
    'countryId': 'LSO',
    'countryName': 'LESOTHO'
  },
  {
    'countryId': 'LTU',
    'countryName': 'LITHUANIA'
  },
  {
    'countryId': 'LUX',
    'countryName': 'LUXEMBOURG'
  },
  {
    'countryId': 'LVA',
    'countryName': 'LATVIA'
  },
  {
    'countryId': 'MAC',
    'countryName': 'MACAU'
  },
  {
    'countryId': 'MAR',
    'countryName': 'MOROCCO'
  },
  {
    'countryId': 'MCO',
    'countryName': 'MONACO'
  },
  {
    'countryId': 'MDA',
    'countryName': 'MOLDOVA, REPUBLIC OF'
  },
  {
    'countryId': 'MDG',
    'countryName': 'MADAGASCAR'
  },
  {
    'countryId': 'MDV',
    'countryName': 'MALDIVES'
  },
  {
    'countryId': 'MEX',
    'countryName': 'MEXICO'
  },
  {
    'countryId': 'MHL',
    'countryName': 'MARSHALL ISLANDS'
  },
  {
    'countryId': 'MKD',
    'countryName': 'MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF'
  },
  {
    'countryId': 'MLI',
    'countryName': 'MALI'
  },
  {
    'countryId': 'MLT',
    'countryName': 'MALTA'
  },
  {
    'countryId': 'MMR',
    'countryName': 'MYANMAR'
  },
  {
    'countryId': 'MNE',
    'countryName': 'MONTENEGRO'
  },
  {
    'countryId': 'MNG',
    'countryName': 'MONGOLIA'
  },
  {
    'countryId': 'MNP',
    'countryName': 'NORTHERN MARIANA ISLANDS'
  },
  {
    'countryId': 'MOZ',
    'countryName': 'MOZAMBIQUE'
  },
  {
    'countryId': 'MRT',
    'countryName': 'MAURITANIA'
  },
  {
    'countryId': 'MSR',
    'countryName': 'MONTSERRAT'
  },
  {
    'countryId': 'MTQ',
    'countryName': 'MARTINIQUE'
  },
  {
    'countryId': 'MUS',
    'countryName': 'MAURITIUS'
  },
  {
    'countryId': 'MWI',
    'countryName': 'MALAWI'
  },
  {
    'countryId': 'MYS',
    'countryName': 'MALAYSIA'
  },
  {
    'countryId': 'MYT',
    'countryName': 'MAYOTTE'
  },
  {
    'countryId': 'NAM',
    'countryName': 'NAMIBIA'
  },
  {
    'countryId': 'NCL',
    'countryName': 'NEW CALEDONIA'
  },
  {
    'countryId': 'NER',
    'countryName': 'NIGER'
  },
  {
    'countryId': 'NFK',
    'countryName': 'NORFOLK ISLAND'
  },
  {
    'countryId': 'NGA',
    'countryName': 'NIGERIA'
  },
  {
    'countryId': 'NIC',
    'countryName': 'NICARAGUA'
  },
  {
    'countryId': 'NIU',
    'countryName': 'NIUE'
  },
  {
    'countryId': 'NLD',
    'countryName': 'NETHERLANDS'
  },
  {
    'countryId': 'NOR',
    'countryName': 'NORWAY'
  },
  {
    'countryId': 'NPL',
    'countryName': 'NEPAL'
  },
  {
    'countryId': 'NRU',
    'countryName': 'NAURU'
  },
  {
    'countryId': 'NZL',
    'countryName': 'NEW ZEALAND'
  },
  {
    'countryId': 'OMN',
    'countryName': 'OMAN'
  },
  {
    'countryId': 'PAK',
    'countryName': 'PAKISTAN'
  },
  {
    'countryId': 'PAN',
    'countryName': 'PANAMA'
  },
  {
    'countryId': 'PCN',
    'countryName': 'PITCAIRN'
  },
  {
    'countryId': 'PER',
    'countryName': 'PERU'
  },
  {
    'countryId': 'PHL',
    'countryName': 'PHILIPPINES'
  },
  {
    'countryId': 'PLW',
    'countryName': 'PALAU'
  },
  {
    'countryId': 'PNG',
    'countryName': 'PAPUA NEW GUINEA'
  },
  {
    'countryId': 'POL',
    'countryName': 'POLAND'
  },
  {
    'countryId': 'PRK',
    'countryName': 'KOREA, DEMOCRATIC PEOPLE\'S REPUBLIC OF'
  },
  {
    'countryId': 'PRT',
    'countryName': 'PORTUGAL'
  },
  {
    'countryId': 'PRY',
    'countryName': 'PARAGUAY'
  },
  {
    'countryId': 'PYF',
    'countryName': 'FRENCH POLYNESIA'
  },
  {
    'countryId': 'QAT',
    'countryName': 'QATAR'
  },
  {
    'countryId': 'REU',
    'countryName': 'REUNION'
  },
  {
    'countryId': 'ROU',
    'countryName': 'ROMANIA'
  },
  {
    'countryId': 'RUS',
    'countryName': 'RUSSIAN FEDERATION'
  },
  {
    'countryId': 'RWA',
    'countryName': 'RWANDA'
  },
  {
    'countryId': 'SAU',
    'countryName': 'SAUDI ARABIA'
  },
  {
    'countryId': 'SDN',
    'countryName': 'SUDAN'
  },
  {
    'countryId': 'SEN',
    'countryName': 'SENEGAL'
  },
  {
    'countryId': 'SGP',
    'countryName': 'SINGAPORE'
  },
  {
    'countryId': 'SGS',
    'countryName': 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS'
  },
  {
    'countryId': 'SHN',
    'countryName': 'ST. HELENA'
  },
  {
    'countryId': 'SJM',
    'countryName': 'SVALBARD AND JAN MAYEN ISLANDS'
  },
  {
    'countryId': 'SLB',
    'countryName': 'SOLOMON ISLANDS'
  },
  {
    'countryId': 'SLE',
    'countryName': 'SIERRA LEONE'
  },
  {
    'countryId': 'SLV',
    'countryName': 'EL SALVADOR'
  },
  {
    'countryId': 'SMR',
    'countryName': 'SAN MARINO'
  },
  {
    'countryId': 'SOM',
    'countryName': 'SOMALIA'
  },
  {
    'countryId': 'SPM',
    'countryName': 'ST. PIERRE AND MIQUELON'
  },
  {
    'countryId': 'SRB',
    'countryName': 'SERBIA'
  },
  {
    'countryId': 'STP',
    'countryName': 'SAO TOME AND PRINCIPE'
  },
  {
    'countryId': 'SUR',
    'countryName': 'SURINAME'
  },
  {
    'countryId': 'SVK',
    'countryName': 'SLOVAKIA  Slovak Republic'
  },
  {
    'countryId': 'SVN',
    'countryName': 'SLOVENIA'
  },
  {
    'countryId': 'SWE',
    'countryName': 'SWEDEN'
  },
  {
    'countryId': 'SWZ',
    'countryName': 'SWAZILAND'
  },
  {
    'countryId': 'SYC',
    'countryName': 'SEYCHELLES'
  },
  {
    'countryId': 'SYR',
    'countryName': 'SYRIAN ARAB REPUBLIC'
  },
  {
    'countryId': 'TCA',
    'countryName': 'TURKS AND CAICOS ISLANDS'
  },
  {
    'countryId': 'TCD',
    'countryName': 'CHAD'
  },
  {
    'countryId': 'TGO',
    'countryName': 'TOGO'
  },
  {
    'countryId': 'THA',
    'countryName': 'THAILAND'
  },
  {
    'countryId': 'TJK',
    'countryName': 'TAJIKISTAN'
  },
  {
    'countryId': 'TKL',
    'countryName': 'TOKELAU'
  },
  {
    'countryId': 'TKM',
    'countryName': 'TURKMENISTAN'
  },
  {
    'countryId': 'TLS',
    'countryName': 'TIMOR-LESTE (FORMERLY EAST TIMOR)'
  },
  {
    'countryId': 'TON',
    'countryName': 'TONGA'
  },
  {
    'countryId': 'TTO',
    'countryName': 'TRINIDAD AND TOBAGO'
  },
  {
    'countryId': 'TUN',
    'countryName': 'TUNISIA'
  },
  {
    'countryId': 'TUR',
    'countryName': 'TURKEY'
  },
  {
    'countryId': 'TUV',
    'countryName': 'TUVALU'
  },
  {
    'countryId': 'TWN',
    'countryName': 'TAIWAN, PROVINCE OF CHINA'
  },
  {
    'countryId': 'TZA',
    'countryName': 'TANZANIA, UNITED REPUBLIC OF'
  },
  {
    'countryId': 'UGA',
    'countryName': 'UGANDA'
  },
  {
    'countryId': 'UKR',
    'countryName': 'UKRAINE'
  },
  {
    'countryId': 'UMI',
    'countryName': 'UNITED STATES MINOR OUTLYING ISLANDS'
  },
  {
    'countryId': 'URY',
    'countryName': 'URUGUAY'
  },
  {
    'countryId': 'USA',
    'countryName': 'UNITED STATES'
  },
  {
    'countryId': 'UZB',
    'countryName': 'UZBEKISTAN'
  },
  {
    'countryId': 'VAT',
    'countryName': 'HOLY SEE  VATICAN CITY STATE'
  },
  {
    'countryId': 'VCT',
    'countryName': 'SAINT VINCENT AND THE GRENADINES'
  },
  {
    'countryId': 'VEN',
    'countryName': 'VENEZUELA'
  },
  {
    'countryId': 'VGB',
    'countryName': 'VIRGIN ISLANDS  BRITISH'
  },
  {
    'countryId': 'VIR',
    'countryName': 'VIRGIN ISLANDS  U.S.'
  },
  {
    'countryId': 'VNM',
    'countryName': 'VIET NAM'
  },
  {
    'countryId': 'VUT',
    'countryName': 'VANUATU'
  },
  {
    'countryId': 'WLF',
    'countryName': 'WALLIS AND FUTUNA ISLANDS'
  },
  {
    'countryId': 'WSM',
    'countryName': 'SAMOA'
  },
  {
    'countryId': 'YEM',
    'countryName': 'YEMEN'
  },
  {
    'countryId': 'ZAF',
    'countryName': 'SOUTH AFRICA'
  },
  {
    'countryId': 'ZMB',
    'countryName': 'ZAMBIA'
  },
  {
    'countryId': 'ZWE',
    'countryName': 'ZIMBABWE'
  }
];
